module.exports = __webpack_public_path__ + "./assets/img/step2.34ad3304.svg";